var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SectionTransformTable', [_c('ModalSMS', {
    attrs: {
      "data": _vm.detailData,
      "isShow": _vm.isShowModal
    },
    on: {
      "refetch": _vm.refetchData,
      "update:isShow": function ($event) {
        _vm.isShowModal = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowModal = $event;
      }
    }
  }), _c('SearchList', {
    attrs: {
      "title": _vm.$t('ar_client_message'),
      "buttonText": "ar_common_search"
    },
    on: {
      "search": _vm.refetchData
    }
  }, [_c('FormItems', {
    attrs: {
      "formData": _vm.formData,
      "items": _vm.formItems
    },
    on: {
      "update:formData": function ($event) {
        _vm.formData = $event;
      },
      "update:form-data": function ($event) {
        _vm.formData = $event;
      }
    }
  })], 1), _c('b-card', [_c('EzTable', {
    ref: "tableRef",
    attrs: {
      "selectionConfig": {
        hideSelectAll: true,
        hideSelect: !_vm.isValidPermission(_vm.AR_IPSMS01)
      },
      "excelExport": _vm.arClient.api_ExcelAP_RSMS01,
      "excel-export-api-code": "AR_RSMS03",
      "dataSourceParams": _vm.formData,
      "actions": _vm.actions,
      "columns": _vm.columns,
      "dataSource": _vm.arClient.api_AR_RSMS01
    },
    on: {
      "selection-changed": _vm.onSelectionChanged,
      "action-1": _vm.viewDetailSMS,
      "action-2": function (data) {
        return _vm.deleteData({
          ArPaymentSMSDetail: {
            Id: data.data.Id
          }
        });
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }